export enum KontobroerType {
  FFLÆFx = "FFLÆFx",
  TB = "TB",
  KontobroerBeregnet = "KontobroerBeregnet",
  KorrektionerTilVertikaleKontobroer = "KorrektionerTilVertikaleKontobroer",
  VertikaleKontobroerInklKorrektioner = "VertikaleKontobroerInklKorrektioner",
}

export interface KontobroView {
  kontoFra: string;
  kontoTil: string;
  beløb?: number;
  promille: number;
  comment?: string;
  fromCorrection?: boolean;
}

export interface GetKontobroQueryView {
  latestDatetime: Date;
  basisbroer: KontobroView[];
}

export interface UpsertKontoFraCorrectionsCommand {
  kontoFra: string;
  year: number;
  corrections: Correction[];
}

export interface Correction {
  kontoTil: string;
  promille: number;
  comment?: string;
}
